import * as React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { useI18next } from "gatsby-plugin-react-i18next";
import { useMetadata } from "hooks/useMetadata";

export const Seo = () => {
    const metadata = useMetadata();
    const {
        languages,
        language,
        originalPath,
        defaultLanguage,
        siteUrl = "http://localhost:8000",
    } = useI18next();
    const createUrlWithLang = (lng: string) => {
        const url = `${siteUrl}${
            lng === defaultLanguage ? "" : `/${lng}`
        }${originalPath}`;
        return url.endsWith("/") ? url : `${url}/`;
    };

    return (
        <GatsbySeo
            title={metadata?.title ?? ""}
            description={metadata?.description ?? ""}
            canonical={createUrlWithLang(language)}
            language={language}
            languageAlternates={[
                ...languages.map((lng) => ({
                    hrefLang: lng,
                    href: createUrlWithLang(lng),
                })),
                {
                    hrefLang: "x-default",
                    href: createUrlWithLang(defaultLanguage),
                },
            ]}
            openGraph={{
                type: "game",
                title: metadata?.title ?? "",
                description: metadata?.description ?? "",
                site_name: metadata?.title ?? "",
                images: [
                    {
                        url: metadata?.image ?? "",
                    },
                ],
            }}
            twitter={{
                cardType: "summary_large_image",
            }}
        />
    );
};
